import React from 'react';
export const Bin = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 0.5H6.5L5.5 1.5H2V3.5H16V1.5H12.5L11.5 0.5ZM13 6.5V16.5H5V6.5H13ZM3 4.5H15V16.5C15 17.6 14.1 18.5 13 18.5H5C3.9 18.5 3 17.6 3 16.5V4.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
